const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let nextPage = currentPage + 1;
  let nextPageUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+nextPage);
  const additionalUrlParams = $('[data-next-url]').val().indexOf('&');
  if (additionalUrlParams > -1) {
    nextPageUrl = nextPageUrl.substring(0, additionalUrlParams)
  }

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextPageUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();
    },
    complete: function() {
      if (nextPage <= totalPages) {
        if (nextPage != totalPages) {
          document.querySelector('input[data-next-url]').dataset.nextUrl =  nextPageUrl;
          document.querySelector('input[data-next-url]').value =  nextPageUrl;
          document.querySelector('input[data-current-page]').dataset.currentPage = nextPage;
          document.querySelector('input[data-current-page]').value = nextPage;
          checkVisibility();
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (nextPage == totalPages) {
          button.remove();
        }
      } 
    }
  })
}

const checkVisibility = (isFirst) => {
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  if (!isFirst) return;
  spinnerList.forEach(spinner => {
    sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadItems(spinner);
          }
        })
      }
    );

    sectionObserver.observe(spinner);
  })
}

function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  checkVisibility(true);
}

(function () {
  loadMore();
})();